// This icon file is generated automatically.
var LrHandoverOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M1.74 1.43V198.1h196.22V1.43H1.74zm182.44 182.89H15.51V15.65h168.67v168.67zM26.92 88.51V72.38H137.2l-15.41-15.4 9.73-9.73 25.14 25.95 16.21 15.4-145.95-.1zm145.95 23.6v15.42H62.6L78 142.93l-9.73 9.73-25.14-25.14-16.21-15.4h145.96z" } }] }, "name": "lr-handover", "theme": "outlined" };
export default LrHandoverOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/LrHandoverOutlined.js
// module id = 3081
// module chunks = 0